import { render } from "./photo-11.vue?vue&type=template&id=d4003648&scoped=true"
import script from "./photo-11.vue?vue&type=script&lang=js"
export * from "./photo-11.vue?vue&type=script&lang=js"

import "./photo-11.vue?vue&type=style&index=0&id=d4003648&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4003648"]])

export default __exports__